import { render, staticRenderFns } from "./LiveResultsView.vue?vue&type=template&id=6b27fd80"
import script from "./LiveResultsView.vue?vue&type=script&lang=js"
export * from "./LiveResultsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports